document.addEventListener('DOMContentLoaded', function () {
  const prodImage = document.querySelector('.preview-image picture');
  const mediaPreviewItems = document.querySelectorAll('.preview-media img');

  mediaPreviewItems.forEach(item => {
    item.addEventListener('click', function () {
      prodImage
        .querySelector('source[media="(min-width: 1440px)"]')
        .setAttribute(
          'srcset',
          `${this.src.replace(/_\d+x\./, '_824x.')}, ${this.src.replace(/_\d+x\./, '_1648x.')} 2x`
        );
      prodImage
        .querySelector('source[media="(min-width: 1024px)"]')
        .setAttribute(
          'srcset',
          `${this.src.replace(/_\d+x\./, '_528x.')}, ${this.src.replace(/_\d+x\./, '_1056x.')} 2x`
        );

      document
        .querySelectorAll('.preview-media div')
        .forEach(div => div.classList.remove('active'));
      this.parentElement.classList.add('active');
    });
  });
  const mediaDivs = document.querySelectorAll('.preview-media .swiper-slide');
  const slideCount = mediaDivs.length;

  let slidesPerView;

  if (slideCount > 6) {
    slidesPerView = 6.2;
  } else if (slideCount === 6) {
    slidesPerView = 6;
  } else if (slideCount === 5) {
    slidesPerView = 4.2;
  } else {
    slidesPerView = 4;
  }

  if (window.innerWidth >= 991) {
    var swiper = new Swiper('.horizontal-media .preview-media .swiper', {
      slidesPerView: slidesPerView,
      spaceBetween: 8,
      autoplay: false,
      navigation: {
        nextEl: '.preview-media .button.next',
        prevEl: '.preview-media .button.prev'
      },
      breakpoints: {}
    });
    swiper.on('slideChange', swiper => {
      calculateScrollPercentage(swiper, '');
    });
  }
  document
    .querySelector('.horizontal-media .product-image__img')
    .addEventListener('click', function () {
      const activeGallery = document.querySelector(
        '.swiper-slide.active .product_gallery'
      );
      if (activeGallery) activeGallery.click();
    });
});
